import { ExternalLink } from 'lucide-react';
import {
  KYC_APERTUM_URL,
  needsDidOnboarding,
  type DidGateReason,
} from '../web3/didEligibility';

type Props = {
  reason?: DidGateReason | null;
  message?: string;
  compact?: boolean;
  centered?: boolean;
};

const GetDidCta = ({ reason, message, compact = false, centered = false }: Props) => {
  if (reason && !needsDidOnboarding(reason)) return null;

  return (
    <div
      data-sf="get-did-cta"
      className={
        compact
          ? `rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-950${
              centered ? ' text-center' : ''
            }`
          : `rounded-xl border border-amber-200 bg-amber-50 p-5 text-amber-950${
              centered ? ' mx-auto flex max-w-xl flex-col items-center text-center' : ''
            }`
      }
    >
      <p className={compact ? 'mb-2' : 'mb-3 text-base'}>
        {message ||
          'This wallet does not have a Global DID yet. Complete KYC on Apertum to receive one, then come back and apply.'}
      </p>
      <a
        href={KYC_APERTUM_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-white hover:bg-primary-600"
      >
        Get a Global DID
        <ExternalLink size={14} />
      </a>
      <p className="mt-2 text-xs text-amber-800">Opens kyc.apertum.io</p>
    </div>
  );
};

export default GetDidCta;
